import React, { useState, useEffect } from 'react';
import { Button, Col, Form, FormInput, FormResetButton, Row, Table, notification } from '@digital/ui';
import { Modal, Icon, Tooltip } from 'antd';
import { UsuarioTableProps } from '@app/api/usuario';
import { compareText } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';

interface ModalColaboradorProps {
  usuarios: UsuarioTableProps[];
  definirValorColoborador: (value: UsuarioTableProps) => void;
}

const ModalColaborador = (props: ModalColaboradorProps) => {

  const { usuarios, definirValorColoborador } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<UsuarioTableProps[]>([]);
  const [pageInicial, setPageInicial] = useState<number>(1);


  useEffect(() => {
    setSelectedRows([]);
    setPageInicial(1);
  }, [visible]);

  const showModalOrHide = () => {
    setVisible(!visible);
  }

  useEffect(() => { console.log('pageInicial', pageInicial) }, [pageInicial]);

  return (
    <>
      <div>
        <Tooltip title="Adicionar colaborador">
          <Button
            style={{ marginTop: '15px', maxHeight: '32px' }}
            onClick={showModalOrHide}
            icon="commons-plus"
            size="small"
          />
        </Tooltip>
        <Modal
          visible={visible}
          width={1024}
          title="Colaboradores"
          onCancel={showModalOrHide}
          footer={[
            <Button
              type='default'
              onClick={showModalOrHide}>
              Fechar
            </Button>,
            <Button
              type="default"
              onClick={() => {
                if (selectedRows.length > 0) {
                  definirValorColoborador(selectedRows[0]);
                  showModalOrHide();
                } else {
                  notification.error('Você deve selecionar um item');
                }
              }}>
              Salvar
            </Button>,
          ]}
        >
          <Table
            dataSource={usuarios}
            rowSelection={{
              type: 'radio',
              onChange: (selectedRowKeys, selectedRows) => {
                setSelectedRows(selectedRows);
              },
              selectedRowKeys: selectedRows.map((item) => item.id),
            }}
            columns={[
              {
                title: 'N',
                dataIndex: 'numeroLinha',
                width: '2%'
              },
              {
                title: 'Nome',
                dataIndex: 'nome',
                sorter: (a, b) => compareText(a.nome, b.nome),
                ...mountFormFilterDropDown('nome', 'Pesquisar')
              }
            ]}
            pagination={{
              pageSize: 10,
              current: pageInicial,
              onChange: (page, pageSize) => {
                setPageInicial(page);
              },
            }}
          />
        </Modal>
      </div >
    </>
  )

}

export default ModalColaborador;